import { render, staticRenderFns } from "./DropdownSubMenu.vue?vue&type=template&id=ef4cdf82&scoped=true"
import script from "./DropdownSubMenu.vue?vue&type=script&lang=js"
export * from "./DropdownSubMenu.vue?vue&type=script&lang=js"
import style0 from "./DropdownSubMenu.vue?vue&type=style&index=0&id=ef4cdf82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4cdf82",
  null
  
)

export default component.exports